{
  "filter": {
    "all": "所有供应商",
    "country": "country",
    "direct": "直接供应商",
    "indirectConfidential": "间接供应商，保密",
    "nonConfidential": "间接供应商，非保密"
  },
  "list": {
    "countContact_one": "{{count}} 联系人",
    "countContact_other": "{{count}} 联系人",
    "noAddress": "未提供地址",
    "noSuppliers": "找不到供应商",
    "searchPlaceholder": "搜索",
    "supplierTypePlaceholder": "供应商类型"
  },
  "productionSites": {
    "columns": {
      "confidential": "保密供应商",
      "contactEmail": "联系邮箱",
      "country": "国家",
      "internalCode": "内部代码",
      "name": "名称",
      "parentCompany": "母公司",
      "performedActivities": "执行活动",
      "registrationId": "设施注册编号"
    },
    "filters": {
      "searchPlaceholder": "搜索"
    },
    "search": {
      "placeholder": "搜索"
    },
    "title": "生产地点"
  },
  "repository": {
    "actions": {
      "delete": "删除",
      "edit": "编辑"
    },
    "create": {
      "error": {
        "message": "message",
        "title": "title"
      },
      "success": {
        "message": "message",
        "title": "title"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "message",
        "title": "title"
      },
      "success": {
        "message": "message",
        "title": "title"
      }
    }
  },
  "risk": {
    "high": "高",
    "low": "低",
    "medium": "中",
    "table": {
      "certificationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      },
      "collaborationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      }
    }
  },
  "sort": {
    "averageResponseTime": "averageResponseTime",
    "company": "company",
    "completedProductionSiterequests": "completedProductionSiterequests",
    "completedProductrequests": "completedProductrequests",
    "completedScopeCertificaterequests": "completedScopeCertificaterequests",
    "completedTransactionCertificaterequests": "completedTransactionCertificaterequests",
    "email": "email",
    "lastConnectionDate": "lastConnectionDate",
    "lastReminderDate": "lastReminderDate",
    "name": "name",
    "pendingDocumentrequests": "pendingDocumentrequests",
    "pendingProductionSiterequests": "pendingProductionSiterequests",
    "pendingProductrequests": "pendingProductrequests",
    "pendingScopeCertificaterequests": "pendingScopeCertificaterequests",
    "pendingTransactionCertificaterequests": "pendingTransactionCertificaterequests"
  },
  "subSuppliers": {
    "title": "我的供应商"
  },
  "supplier": {
    "averageResponseTime": "平均响应时间",
    "averageResponseTimeValue_other": "{{nbDays}} 天",
    "informationRequests": "产品请求",
    "lastConnection": "最后连接",
    "lastConnectionValue": "{{nbDays}} 天前",
    "lastReminderSent": "最后发送提醒",
    "lastReminderSentValue": "{{nbDays}} 天前",
    "noLastConnection": "尚未连接",
    "noLastReminderSent": "尚未发送电子邮件",
    "noResponseTime": "尚未回复",
    "productionSites": "生产地点",
    "scopeCertificates": "范围证书",
    "transactionCertificates": "交易证书",
    "transferContact_one": "将 {{count}} 个未完成请求\n转移给其他联系人",
    "transferContact_other": "将 {{count}} 个未完成请求\n转移给其他联系人",
    "transferContactCertificates_other": "transferContactCertificates",
    "transferModal": {
      "companyCountry": "companyCountry",
      "companyCountryPlaceholder": "companyCountryPlaceholder",
      "companyName": "companyName",
      "companyNamePlaceholder": "companyNamePlaceholder",
      "email": "电子邮件",
      "emailPlaceholder": "例如：john@example.com",
      "name": "名称",
      "namePlaceholder": "例如：约翰·史密斯",
      "title": "转移联系人",
      "transfer": "转移",
      "transferSuccess_other": "transferSuccess"
    }
  },
  "title": "商业伙伴"
}
